import { combine, createEffect, createEvent, createStore } from 'effector';
import { createGate } from 'effector-react';
import { pending } from 'patronum';
import { apiImportMethods } from '../../api';
import {
  CheckNotReadStatusResponse,
  ImportInterruptPayload,
  ImportInterruptResponse,
  ImportReadNotificationPayload,
  ImportReadNotificationResponse,
  Process,
  processStatuses,
} from '../../types';
import { getBadgeColorAndNumber } from './helpers/getBadgeColorAndNumber';

export const ImportTemporalGate = createGate();

export const CHECK_NOT_READ_STATUS_TIMEOUT = 5000;

export const $notReadImports = createStore<Process[]>([]);
export const $openImportsPopperCounter = createStore(0);

export const $getBadgeColorAndNumber = combine($notReadImports, (notReadImports) =>
  getBadgeColorAndNumber(notReadImports)
);

export const $processingImports = combine($notReadImports, (notReadImports) =>
  notReadImports.filter(({ status }) => status === processStatuses.processing)
);

/** Внешнее событие для проверки импортов. Нужно запускать это событие после успешного начала импорта в нужном разделе */
export const importsCheckNotReadStatus = createEvent();
/** Внешнее событие, срабатывающее после прочтения успешного импорта. Нужно запускать,
 * чтобы обновить таблицу после успешного импорта, если пользователь находится
 * на той же странице, где был запущен импорт */
export const refreshTableAfterSuccessImportOnSamePage = createEvent();

export const fxImportsCheckNotReadStatus = createEffect<
  void,
  CheckNotReadStatusResponse,
  Error
>(apiImportMethods.importsCheckNotReadStatus);
export const fxImportsCheckNotReadStatusManualy = createEffect<
  void,
  CheckNotReadStatusResponse,
  Error
>(apiImportMethods.importsCheckNotReadStatus);

export const importInterrupt = createEvent<string | number>();
export const fxImportInterrupt = createEffect<
  ImportInterruptPayload,
  ImportInterruptResponse,
  Error
>(apiImportMethods.importInterrupt);

export const importReadNotification = createEvent<(string | number)[]>();
export const fxImportReadNotification = createEffect<
  ImportReadNotificationPayload,
  ImportReadNotificationResponse,
  Error
>(apiImportMethods.importReadNotification);

/** Передавать все эффекты раздела */
export const $isLoading = pending({
  effects: [fxImportsCheckNotReadStatusManualy, fxImportInterrupt],
});
